/* tslint:disable */
/* eslint-disable */
/**
 * grpc/v1/search_service.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common'
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from '../base'
// @ts-ignore
import type { RequestArgs } from '../base'
// @ts-ignore
import { RpcStatus } from '../models'
// @ts-ignore
import { V1GlobalSearchResponse } from '../models'
// @ts-ignore
import { V1RunBackfillRequest } from '../models'
// @ts-ignore
import { V1RunBackfillResponse } from '../models'
// @ts-ignore
import { V1SearchEntityResponse } from '../models'
/**
 * SearchServiceApi - axios parameter creator
 * @export
 */
export const SearchServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Searches every entity type at once and returns the best matches of each, grouped by type. Built for a search box that shows suggestions as the user types.
     * @param {string} [query] Search query. Matches whole words and word prefixes. Required.
     * @param {Array<SearchServiceGlobalSearchTypesEnum>} [types] Restrict the search to these entity types. Empty means all of them.   - SEARCH_ENTITY_TYPE_AGENT: Real estate agent. Company names are matched with transliteration applied to the indexed text, so a name typed in either script is found.  - SEARCH_ENTITY_TYPE_USER: CRM user. Administrative records: excluded from the global search and reachable only through the single-entity search, and only by roles with full access (DEV-707).  - SEARCH_ENTITY_TYPE_ARTICLE: Published article. Excluded from the global search and reachable through the single-entity search behind the article list. Articles have no owning manager and are not restricted, so any authenticated user sees them (DEV-1099).
     * @param {number} [limitPerType] How many results to return per entity type. Zero means the default of the service, which also caps the value.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchServiceGlobalSearch: async (
      query?: string,
      types?: Array<SearchServiceGlobalSearchTypesEnum>,
      limitPerType?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/search`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (query !== undefined) {
        localVarQueryParameter['query'] = query
      }

      if (types) {
        localVarQueryParameter['types'] = types
      }

      if (limitPerType !== undefined) {
        localVarQueryParameter['limitPerType'] = limitPerType
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Answers immediately and keeps working in the background; progress goes to the service log. Safe to repeat: indexing the same record twice changes nothing.  Internal note: restricted to roles with full access, because it reads source records under the caller token and therefore bypasses the per-manager filter.
     * @summary Rebuilds the search index from the services that own the data.
     * @param {V1RunBackfillRequest} body Which entity types to reindex.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchServiceRunBackfill: async (
      body: V1RunBackfillRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('searchServiceRunBackfill', 'body', body)
      const localVarPath = `/api/v1/search/backfill`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Differs from the global search in three ways: it covers a single type, it pages through all matches rather than capping them, and it accepts an empty query — which turns it into a filtered listing ordered by recency.
     * @summary Searches one entity type with paging and filters.
     * @param {SearchServiceSearchEntityTypeEnum} [type] The entity type to search. Required.   - SEARCH_ENTITY_TYPE_AGENT: Real estate agent. Company names are matched with transliteration applied to the indexed text, so a name typed in either script is found.  - SEARCH_ENTITY_TYPE_USER: CRM user. Administrative records: excluded from the global search and reachable only through the single-entity search, and only by roles with full access (DEV-707).  - SEARCH_ENTITY_TYPE_ARTICLE: Published article. Excluded from the global search and reachable through the single-entity search behind the article list. Articles have no owning manager and are not restricted, so any authenticated user sees them (DEV-1099).
     * @param {string} [query] Search query. Matches whole words and word prefixes. May be empty, which turns the call into a filtered listing.
     * @param {Array<string>} [userFilterRoles] Role keys: ADMIN, MANAGER, AGENT, ADMIN_USER, HOS, MARKETER, CEO.
     * @param {Array<string>} [userFilterStatuses] Account states: ACTIVE, INACTIVE, PENDING, INVALID.
     * @param {number} [page] Page number, starting at 1. Zero is treated as the first page.
     * @param {number} [perPage] Page size. Zero means the default of the service, which also caps how large a page may be.
     * @param {SearchServiceSearchEntitySortEnum} [sort]  - SEARCH_SORT_UNSPECIFIED: Let the server choose: by relevance when a query is given, by recency otherwise.  - SEARCH_SORT_RELEVANCE: Best match first. Requires a non-empty query.  - SEARCH_SORT_RECENT: Most recently changed first.
     * @param {Array<string>} [articleFilterTypes] Article types, by their enum names: ARTICLE_TYPE_NEWS, ARTICLE_TYPE_HANDBOOK and so on.
     * @param {boolean} [articleFilterFeatured] Keep only featured articles, or only non-featured ones. Unset means both.
     * @param {Array<string>} [articleFilterTagNames] Tag names. An article matches when it carries any one of them.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchServiceSearchEntity: async (
      type?: SearchServiceSearchEntityTypeEnum,
      query?: string,
      userFilterRoles?: Array<string>,
      userFilterStatuses?: Array<string>,
      page?: number,
      perPage?: number,
      sort?: SearchServiceSearchEntitySortEnum,
      articleFilterTypes?: Array<string>,
      articleFilterFeatured?: boolean,
      articleFilterTagNames?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/search/entity`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (type !== undefined) {
        localVarQueryParameter['type'] = type
      }

      if (query !== undefined) {
        localVarQueryParameter['query'] = query
      }

      if (userFilterRoles) {
        localVarQueryParameter['userFilter.roles'] = userFilterRoles
      }

      if (userFilterStatuses) {
        localVarQueryParameter['userFilter.statuses'] = userFilterStatuses
      }

      if (page !== undefined) {
        localVarQueryParameter['page'] = page
      }

      if (perPage !== undefined) {
        localVarQueryParameter['perPage'] = perPage
      }

      if (sort !== undefined) {
        localVarQueryParameter['sort'] = sort
      }

      if (articleFilterTypes) {
        localVarQueryParameter['articleFilter.types'] = articleFilterTypes
      }

      if (articleFilterFeatured !== undefined) {
        localVarQueryParameter['articleFilter.featured'] = articleFilterFeatured
      }

      if (articleFilterTagNames) {
        localVarQueryParameter['articleFilter.tagNames'] = articleFilterTagNames
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * SearchServiceApi - functional programming interface
 * @export
 */
export const SearchServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SearchServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Searches every entity type at once and returns the best matches of each, grouped by type. Built for a search box that shows suggestions as the user types.
     * @param {string} [query] Search query. Matches whole words and word prefixes. Required.
     * @param {Array<SearchServiceGlobalSearchTypesEnum>} [types] Restrict the search to these entity types. Empty means all of them.   - SEARCH_ENTITY_TYPE_AGENT: Real estate agent. Company names are matched with transliteration applied to the indexed text, so a name typed in either script is found.  - SEARCH_ENTITY_TYPE_USER: CRM user. Administrative records: excluded from the global search and reachable only through the single-entity search, and only by roles with full access (DEV-707).  - SEARCH_ENTITY_TYPE_ARTICLE: Published article. Excluded from the global search and reachable through the single-entity search behind the article list. Articles have no owning manager and are not restricted, so any authenticated user sees them (DEV-1099).
     * @param {number} [limitPerType] How many results to return per entity type. Zero means the default of the service, which also caps the value.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchServiceGlobalSearch(
      query?: string,
      types?: Array<SearchServiceGlobalSearchTypesEnum>,
      limitPerType?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GlobalSearchResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.searchServiceGlobalSearch(
        query,
        types,
        limitPerType,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['SearchServiceApi.searchServiceGlobalSearch']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Answers immediately and keeps working in the background; progress goes to the service log. Safe to repeat: indexing the same record twice changes nothing.  Internal note: restricted to roles with full access, because it reads source records under the caller token and therefore bypasses the per-manager filter.
     * @summary Rebuilds the search index from the services that own the data.
     * @param {V1RunBackfillRequest} body Which entity types to reindex.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchServiceRunBackfill(
      body: V1RunBackfillRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1RunBackfillResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.searchServiceRunBackfill(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['SearchServiceApi.searchServiceRunBackfill']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Differs from the global search in three ways: it covers a single type, it pages through all matches rather than capping them, and it accepts an empty query — which turns it into a filtered listing ordered by recency.
     * @summary Searches one entity type with paging and filters.
     * @param {SearchServiceSearchEntityTypeEnum} [type] The entity type to search. Required.   - SEARCH_ENTITY_TYPE_AGENT: Real estate agent. Company names are matched with transliteration applied to the indexed text, so a name typed in either script is found.  - SEARCH_ENTITY_TYPE_USER: CRM user. Administrative records: excluded from the global search and reachable only through the single-entity search, and only by roles with full access (DEV-707).  - SEARCH_ENTITY_TYPE_ARTICLE: Published article. Excluded from the global search and reachable through the single-entity search behind the article list. Articles have no owning manager and are not restricted, so any authenticated user sees them (DEV-1099).
     * @param {string} [query] Search query. Matches whole words and word prefixes. May be empty, which turns the call into a filtered listing.
     * @param {Array<string>} [userFilterRoles] Role keys: ADMIN, MANAGER, AGENT, ADMIN_USER, HOS, MARKETER, CEO.
     * @param {Array<string>} [userFilterStatuses] Account states: ACTIVE, INACTIVE, PENDING, INVALID.
     * @param {number} [page] Page number, starting at 1. Zero is treated as the first page.
     * @param {number} [perPage] Page size. Zero means the default of the service, which also caps how large a page may be.
     * @param {SearchServiceSearchEntitySortEnum} [sort]  - SEARCH_SORT_UNSPECIFIED: Let the server choose: by relevance when a query is given, by recency otherwise.  - SEARCH_SORT_RELEVANCE: Best match first. Requires a non-empty query.  - SEARCH_SORT_RECENT: Most recently changed first.
     * @param {Array<string>} [articleFilterTypes] Article types, by their enum names: ARTICLE_TYPE_NEWS, ARTICLE_TYPE_HANDBOOK and so on.
     * @param {boolean} [articleFilterFeatured] Keep only featured articles, or only non-featured ones. Unset means both.
     * @param {Array<string>} [articleFilterTagNames] Tag names. An article matches when it carries any one of them.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async searchServiceSearchEntity(
      type?: SearchServiceSearchEntityTypeEnum,
      query?: string,
      userFilterRoles?: Array<string>,
      userFilterStatuses?: Array<string>,
      page?: number,
      perPage?: number,
      sort?: SearchServiceSearchEntitySortEnum,
      articleFilterTypes?: Array<string>,
      articleFilterFeatured?: boolean,
      articleFilterTagNames?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1SearchEntityResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.searchServiceSearchEntity(
        type,
        query,
        userFilterRoles,
        userFilterStatuses,
        page,
        perPage,
        sort,
        articleFilterTypes,
        articleFilterFeatured,
        articleFilterTagNames,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['SearchServiceApi.searchServiceSearchEntity']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * SearchServiceApi - factory interface
 * @export
 */
export const SearchServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = SearchServiceApiFp(configuration)
  return {
    /**
     *
     * @summary Searches every entity type at once and returns the best matches of each, grouped by type. Built for a search box that shows suggestions as the user types.
     * @param {string} [query] Search query. Matches whole words and word prefixes. Required.
     * @param {Array<SearchServiceGlobalSearchTypesEnum>} [types] Restrict the search to these entity types. Empty means all of them.   - SEARCH_ENTITY_TYPE_AGENT: Real estate agent. Company names are matched with transliteration applied to the indexed text, so a name typed in either script is found.  - SEARCH_ENTITY_TYPE_USER: CRM user. Administrative records: excluded from the global search and reachable only through the single-entity search, and only by roles with full access (DEV-707).  - SEARCH_ENTITY_TYPE_ARTICLE: Published article. Excluded from the global search and reachable through the single-entity search behind the article list. Articles have no owning manager and are not restricted, so any authenticated user sees them (DEV-1099).
     * @param {number} [limitPerType] How many results to return per entity type. Zero means the default of the service, which also caps the value.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchServiceGlobalSearch(
      query?: string,
      types?: Array<SearchServiceGlobalSearchTypesEnum>,
      limitPerType?: number,
      options?: any,
    ): AxiosPromise<V1GlobalSearchResponse> {
      return localVarFp
        .searchServiceGlobalSearch(query, types, limitPerType, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Answers immediately and keeps working in the background; progress goes to the service log. Safe to repeat: indexing the same record twice changes nothing.  Internal note: restricted to roles with full access, because it reads source records under the caller token and therefore bypasses the per-manager filter.
     * @summary Rebuilds the search index from the services that own the data.
     * @param {V1RunBackfillRequest} body Which entity types to reindex.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchServiceRunBackfill(
      body: V1RunBackfillRequest,
      options?: any,
    ): AxiosPromise<V1RunBackfillResponse> {
      return localVarFp
        .searchServiceRunBackfill(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Differs from the global search in three ways: it covers a single type, it pages through all matches rather than capping them, and it accepts an empty query — which turns it into a filtered listing ordered by recency.
     * @summary Searches one entity type with paging and filters.
     * @param {SearchServiceSearchEntityTypeEnum} [type] The entity type to search. Required.   - SEARCH_ENTITY_TYPE_AGENT: Real estate agent. Company names are matched with transliteration applied to the indexed text, so a name typed in either script is found.  - SEARCH_ENTITY_TYPE_USER: CRM user. Administrative records: excluded from the global search and reachable only through the single-entity search, and only by roles with full access (DEV-707).  - SEARCH_ENTITY_TYPE_ARTICLE: Published article. Excluded from the global search and reachable through the single-entity search behind the article list. Articles have no owning manager and are not restricted, so any authenticated user sees them (DEV-1099).
     * @param {string} [query] Search query. Matches whole words and word prefixes. May be empty, which turns the call into a filtered listing.
     * @param {Array<string>} [userFilterRoles] Role keys: ADMIN, MANAGER, AGENT, ADMIN_USER, HOS, MARKETER, CEO.
     * @param {Array<string>} [userFilterStatuses] Account states: ACTIVE, INACTIVE, PENDING, INVALID.
     * @param {number} [page] Page number, starting at 1. Zero is treated as the first page.
     * @param {number} [perPage] Page size. Zero means the default of the service, which also caps how large a page may be.
     * @param {SearchServiceSearchEntitySortEnum} [sort]  - SEARCH_SORT_UNSPECIFIED: Let the server choose: by relevance when a query is given, by recency otherwise.  - SEARCH_SORT_RELEVANCE: Best match first. Requires a non-empty query.  - SEARCH_SORT_RECENT: Most recently changed first.
     * @param {Array<string>} [articleFilterTypes] Article types, by their enum names: ARTICLE_TYPE_NEWS, ARTICLE_TYPE_HANDBOOK and so on.
     * @param {boolean} [articleFilterFeatured] Keep only featured articles, or only non-featured ones. Unset means both.
     * @param {Array<string>} [articleFilterTagNames] Tag names. An article matches when it carries any one of them.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchServiceSearchEntity(
      type?: SearchServiceSearchEntityTypeEnum,
      query?: string,
      userFilterRoles?: Array<string>,
      userFilterStatuses?: Array<string>,
      page?: number,
      perPage?: number,
      sort?: SearchServiceSearchEntitySortEnum,
      articleFilterTypes?: Array<string>,
      articleFilterFeatured?: boolean,
      articleFilterTagNames?: Array<string>,
      options?: any,
    ): AxiosPromise<V1SearchEntityResponse> {
      return localVarFp
        .searchServiceSearchEntity(
          type,
          query,
          userFilterRoles,
          userFilterStatuses,
          page,
          perPage,
          sort,
          articleFilterTypes,
          articleFilterFeatured,
          articleFilterTagNames,
          options,
        )
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * SearchServiceApi - object-oriented interface
 * @export
 * @class SearchServiceApi
 * @extends {BaseAPI}
 */
export class SearchServiceApi extends BaseAPI {
  /**
   *
   * @summary Searches every entity type at once and returns the best matches of each, grouped by type. Built for a search box that shows suggestions as the user types.
   * @param {string} [query] Search query. Matches whole words and word prefixes. Required.
   * @param {Array<SearchServiceGlobalSearchTypesEnum>} [types] Restrict the search to these entity types. Empty means all of them.   - SEARCH_ENTITY_TYPE_AGENT: Real estate agent. Company names are matched with transliteration applied to the indexed text, so a name typed in either script is found.  - SEARCH_ENTITY_TYPE_USER: CRM user. Administrative records: excluded from the global search and reachable only through the single-entity search, and only by roles with full access (DEV-707).  - SEARCH_ENTITY_TYPE_ARTICLE: Published article. Excluded from the global search and reachable through the single-entity search behind the article list. Articles have no owning manager and are not restricted, so any authenticated user sees them (DEV-1099).
   * @param {number} [limitPerType] How many results to return per entity type. Zero means the default of the service, which also caps the value.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchServiceApi
   */
  public searchServiceGlobalSearch(
    query?: string,
    types?: Array<SearchServiceGlobalSearchTypesEnum>,
    limitPerType?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return SearchServiceApiFp(this.configuration)
      .searchServiceGlobalSearch(query, types, limitPerType, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Answers immediately and keeps working in the background; progress goes to the service log. Safe to repeat: indexing the same record twice changes nothing.  Internal note: restricted to roles with full access, because it reads source records under the caller token and therefore bypasses the per-manager filter.
   * @summary Rebuilds the search index from the services that own the data.
   * @param {V1RunBackfillRequest} body Which entity types to reindex.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchServiceApi
   */
  public searchServiceRunBackfill(body: V1RunBackfillRequest, options?: RawAxiosRequestConfig) {
    return SearchServiceApiFp(this.configuration)
      .searchServiceRunBackfill(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Differs from the global search in three ways: it covers a single type, it pages through all matches rather than capping them, and it accepts an empty query — which turns it into a filtered listing ordered by recency.
   * @summary Searches one entity type with paging and filters.
   * @param {SearchServiceSearchEntityTypeEnum} [type] The entity type to search. Required.   - SEARCH_ENTITY_TYPE_AGENT: Real estate agent. Company names are matched with transliteration applied to the indexed text, so a name typed in either script is found.  - SEARCH_ENTITY_TYPE_USER: CRM user. Administrative records: excluded from the global search and reachable only through the single-entity search, and only by roles with full access (DEV-707).  - SEARCH_ENTITY_TYPE_ARTICLE: Published article. Excluded from the global search and reachable through the single-entity search behind the article list. Articles have no owning manager and are not restricted, so any authenticated user sees them (DEV-1099).
   * @param {string} [query] Search query. Matches whole words and word prefixes. May be empty, which turns the call into a filtered listing.
   * @param {Array<string>} [userFilterRoles] Role keys: ADMIN, MANAGER, AGENT, ADMIN_USER, HOS, MARKETER, CEO.
   * @param {Array<string>} [userFilterStatuses] Account states: ACTIVE, INACTIVE, PENDING, INVALID.
   * @param {number} [page] Page number, starting at 1. Zero is treated as the first page.
   * @param {number} [perPage] Page size. Zero means the default of the service, which also caps how large a page may be.
   * @param {SearchServiceSearchEntitySortEnum} [sort]  - SEARCH_SORT_UNSPECIFIED: Let the server choose: by relevance when a query is given, by recency otherwise.  - SEARCH_SORT_RELEVANCE: Best match first. Requires a non-empty query.  - SEARCH_SORT_RECENT: Most recently changed first.
   * @param {Array<string>} [articleFilterTypes] Article types, by their enum names: ARTICLE_TYPE_NEWS, ARTICLE_TYPE_HANDBOOK and so on.
   * @param {boolean} [articleFilterFeatured] Keep only featured articles, or only non-featured ones. Unset means both.
   * @param {Array<string>} [articleFilterTagNames] Tag names. An article matches when it carries any one of them.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SearchServiceApi
   */
  public searchServiceSearchEntity(
    type?: SearchServiceSearchEntityTypeEnum,
    query?: string,
    userFilterRoles?: Array<string>,
    userFilterStatuses?: Array<string>,
    page?: number,
    perPage?: number,
    sort?: SearchServiceSearchEntitySortEnum,
    articleFilterTypes?: Array<string>,
    articleFilterFeatured?: boolean,
    articleFilterTagNames?: Array<string>,
    options?: RawAxiosRequestConfig,
  ) {
    return SearchServiceApiFp(this.configuration)
      .searchServiceSearchEntity(
        type,
        query,
        userFilterRoles,
        userFilterStatuses,
        page,
        perPage,
        sort,
        articleFilterTypes,
        articleFilterFeatured,
        articleFilterTagNames,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * @export
 */
export const SearchServiceGlobalSearchTypesEnum = {
  Invalid: 'SEARCH_ENTITY_TYPE_INVALID',
  Client: 'SEARCH_ENTITY_TYPE_CLIENT',
  Deal: 'SEARCH_ENTITY_TYPE_DEAL',
  Property: 'SEARCH_ENTITY_TYPE_PROPERTY',
  Agent: 'SEARCH_ENTITY_TYPE_AGENT',
  PartnerCompany: 'SEARCH_ENTITY_TYPE_PARTNER_COMPANY',
  User: 'SEARCH_ENTITY_TYPE_USER',
  Article: 'SEARCH_ENTITY_TYPE_ARTICLE',
} as const
export type SearchServiceGlobalSearchTypesEnum =
  (typeof SearchServiceGlobalSearchTypesEnum)[keyof typeof SearchServiceGlobalSearchTypesEnum]
/**
 * @export
 */
export const SearchServiceSearchEntityTypeEnum = {
  Invalid: 'SEARCH_ENTITY_TYPE_INVALID',
  Client: 'SEARCH_ENTITY_TYPE_CLIENT',
  Deal: 'SEARCH_ENTITY_TYPE_DEAL',
  Property: 'SEARCH_ENTITY_TYPE_PROPERTY',
  Agent: 'SEARCH_ENTITY_TYPE_AGENT',
  PartnerCompany: 'SEARCH_ENTITY_TYPE_PARTNER_COMPANY',
  User: 'SEARCH_ENTITY_TYPE_USER',
  Article: 'SEARCH_ENTITY_TYPE_ARTICLE',
} as const
export type SearchServiceSearchEntityTypeEnum =
  (typeof SearchServiceSearchEntityTypeEnum)[keyof typeof SearchServiceSearchEntityTypeEnum]
/**
 * @export
 */
export const SearchServiceSearchEntitySortEnum = {
  Unspecified: 'SEARCH_SORT_UNSPECIFIED',
  Relevance: 'SEARCH_SORT_RELEVANCE',
  Recent: 'SEARCH_SORT_RECENT',
} as const
export type SearchServiceSearchEntitySortEnum =
  (typeof SearchServiceSearchEntitySortEnum)[keyof typeof SearchServiceSearchEntitySortEnum]
